import { RANK_COLORS } from "../data/staffData";

export default function RankBadge({ rank }) {
    const color = RANK_COLORS[rank] || "#8B5CF6";
    return (
        <span
            data-testid={`rank-badge-${rank.toLowerCase().replace(/\s+/g, "-")}`}
            className="inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-[11px] font-semibold tracking-wide"
            style={{
                color,
                borderColor: `${color}55`,
                backgroundColor: `${color}14`,
            }}
        >
            <span
                className="h-1.5 w-1.5 rounded-full"
                style={{ backgroundColor: color }}
            />
            {rank}
        </span>
    );
}
